import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@erpsquad/common/components/typography';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const VendorAITabLabel: React.FC = () => {
    return (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            color: '#7b3bf2'
        }}>
            <AutoAwesomeIcon sx={{ fontSize: 18 }} />
            <Typography type="s3" weight="medium" color="inherit">
                AI Vendor Insights
            </Typography>
        </Box>
    );
};

export default VendorAITabLabel;
